// variable from vendor.js and pug template variables
/* global processData, companyId, companyStaff, company */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './onboarding/App';

ReactDOM.render(
  <App
    processData={processData}
    companyStaff={companyStaff}
    companyId={companyId}
    company={company}
  />,
  document.getElementById('app'),
);
// Uncomment this next line to trigger a warning
// require('Assert')
// require('assert');
if (module.hot) {
  module.hot.accept();
  // module.hot.dispose(function() {
  //   clearInterval(timer);
  // });
}
